import styled from '@emotion/styled/macro'
import { AutoStack } from 'components'
import { Flex } from 'grid'
import { themeColor, themeFont } from 'mixins'
import { Icon } from 'office-ui-fabric-react'
import * as React from 'react'
import { useTranslation } from 'react-i18next'

const StyledFlex = styled(Flex)`
  height: 100%;
  background: repeating-linear-gradient(
    ${(props: { angle?: number }) => props.angle || 45}deg,
    ${themeColor('neutralLight')},
    ${themeColor('neutralLight')} 10px,
    ${themeColor('neutralLighter')} 10px,
    ${themeColor('neutralLighter')} 20px
  );
  ${themeFont('xLarge')};
`
export interface AccessDeniedProps {
  gradientAngle?: number
}

export const AccessDenied: React.FC<AccessDeniedProps> = ({
  gradientAngle,
  children,
}) => {
  const { t } = useTranslation()
  return (
    <StyledFlex
      angle={gradientAngle}
      flex="1"
      justifyContent="center"
      alignItems="center"
    >
      {children || (
        <AutoStack horizontalAlign={'center'}>
          <Icon iconName="Warning" style={{ fontSize: '30px' }} />
          <div style={{ fontSize: '20px' }}>{t('accessDenied')}</div>
        </AutoStack>
      )}
    </StyledFlex>
  )
}
